<template>
	<div>
		<v-row class="mt-3 body-transaction-product body-transaction-product-sm">
			<v-col cols="12" class="pt-0">
				<v-card class="pa-3 elevation-0 rounded-xl hover-shadow">
					<div class="d-flex flex-wrap justify-center">
						<v-col cols="6" sm="4" md="3" class="pt-0">
							<v-img src="/assets/ilustration/ilustrasi-confirm-transaction.svg"></v-img>
						</v-col>
						<v-col cols="12" class="pb-0 text-center">
							<div class="cl-dark-green font-size-xs-10 font-size-11 font-weight-500">Selamat Anda berhasil melakukan repeat order produk !!</div>
						</v-col>
					</div>
					<v-col cols="12" class="pt-5 pb-1 text-center">
						<div class="cl-dark-green font-size-xs-10 font-size-11 pb-3">
							<span class="font-weight-bold cl-primary cursor-pointer" @click="goToLink">Klik disini</span>
							<span class="pl-1">untuk melihat riwayat repeat order anda atau</span>
						</div>
						<v-btn depressed color="primary" height="45" class="white--text rounded-xl text-capitalize font-weight-bold" @click="reloadPage">
							<span class="pr-2 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">Repeat Order Lagi</span>
							<v-icon>mdi-cart-outline</v-icon>
						</v-btn>
					</v-col>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>

export default {
	components: {
	},
	data() {
		return {
			params: {},
		}
	},
	props: {
		ispremiumtype: Boolean
	},
	computed: {
	},
	methods: {
		goToLink() {
			this.$router.push({ name: 'lap-repeat-order' })
		},
		reloadPage() {
			this.$router.go(this.$router.currentRoute)
		},
	},
	created() {
	},
};
</script>